import validatableWithSyncInitialize from './validatableWithSyncInitialize';
import {valueValidatableClearance} from './valueValidatableInitialize';

const radioGroupInitialize = (RMI, contextId, compId) => validatableWithSyncInitialize(RMI, contextId, compId);

const radioGroupClearance = (RMI, contextId, compId) => valueValidatableClearance(RMI, contextId, compId);

export {radioGroupInitialize, radioGroupClearance};
